import { render, staticRenderFns } from "./ErrorIcon.vue?vue&type=template&id=51ac9c6b&scoped=true&"
import script from "./ErrorIcon.vue?vue&type=script&lang=ts&"
export * from "./ErrorIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorIcon.vue?vue&type=style&index=0&id=51ac9c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac9c6b",
  null
  
)

export default component.exports